import allowed from '@/core/constants/allowed-roles.constant'
import { USERS_ACCESS_ROLES } from '@/modules/sps/constants'

const index = [
  {
    name: 'Culture',
    path: '/culture',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'sps',
      breadcrumb: {
        label: 'core.menu.modules.culture',
        route: 'sps-home',
      },
    },
    children: [
      {
        name: 'SPS',
        path: '/culture/sps',
        meta: {
          allowedRoles: [...allowed.sps.roles],
          breadcrumb: {
            label: 'core.menu.modules.culture',
            route: 'sps-home',
          },
        },
        component: () =>
          import('@/modules/sps/containers/sps.container.vue'),
        children: [
          {
            name: 'sps-home',
            path: '',
            component: () => import(
              '@/modules/sps/pages/home/sps-home.vue'
            ),
          },
          {
            name: 'sps-create-project',
            path: 'create',
            meta: {
              layout: 'wizard',
              breadcrumb: {
                label: 'sps.createSurvey',
                route: 'sps-create-survey',
              },
            },
            component: () =>
              import(
                '@/modules/sps/pages/create-project/create-project.vue'
              ),
          },
          {
            name: 'sps-edit-project',
            path: 'edit/:id',
            meta: {
              layout: 'wizard',
              breadcrumb: {
                label: 'sps.editProjectDetails',
                route: 'sps-edit-project',
              },
            },
            component: () =>
              import(
                '@/modules/sps/pages/edit-project/edit-project.vue'
              ),
          },
          {
            name: 'sps-project-details',
            path: 'project/:id',
            meta: {
              breadcrumb: {
                label: 'sps.projectDetails',
                route: 'sps-project-details',
              },
            },
            component: () =>
              import(
                '@/modules/sps/pages/project-details/project-details.vue'
              ),
          },
          {
            name: 'sps-users-access',
            path: 'project/:id/users-access',
            meta: {
              allowedRoles: USERS_ACCESS_ROLES,
              breadcrumb: {
                label: 'sps.usersAccess.title',
                route: 'sps-users-access',
              },
            },
            component: () =>
              import(
                '@/modules/sps/pages/users-access/users-access.vue'
              ),
          },
          {
            name: 'sps-culture-report',
            path: 'culture-report/:id',
            meta: {
              breadcrumb: {
                label: 'sps.cultureReport.title',
                route: 'sps-culture-report',
              },
            },
            component: () =>
              import(
                '@/modules/sps/pages/culture-report/culture-report.vue'
              ),
          },
        ],
      },
    ],
  },
]

export default index
